<template>
  <div>
    <div class="bg-gray-200 px-2">
      <span class="font-13 font-weight-medium">DRP - Configuração da Malha Logística de Distribuição</span>
    </div>

    <v-tabs centered>
      <v-tab>
        <v-icon left>mdi-clipboard-list</v-icon>
        Malha Logística de Distribuição
      </v-tab>
    </v-tabs>

    <MapaDeSeparacao class="px-2" />
  </div>
</template>

<script>
import MapaDeSeparacao from "@/components/drp/configDrpAutomatizado/MapaDeSeparacao";

export default {
  name: "Index",
  components: {
    MapaDeSeparacao
  },
  setup() {

  }
}
</script>

<style scoped>

</style>
